import React from 'react'
import PropTypes from 'prop-types'
import { DragDrop, StatusBar } from '@uppy/react'

import useUppyImageUpload from 'hooks/useUppyImageUpload'
import Box from 'suitTheme/Box'

import '@uppy/status-bar/dist/style.css'
import styles from './styles.scss'

const ImageUppyUploadZone = (props) => {
  const {
    endpoint,
    imageableType,
    imageableId,
    style,
    height,
    allowedFileTypes,
    imageType,
    subTitle,
    fieldName,
    requestOptions,
  } = props

  const options = {
    allowedFileTypes,
    endpoint,
    image_type: imageType,
    imageable_id: imageableId,
    imageable_type: imageableType,
    fieldName,
    requestOptions,
  }

  const uppy = useUppyImageUpload(options, [imageableId, imageableType])
  if (!uppy){
    return null
  }

  return (
    <Box flexDirection="column" className={styles.root} marginBottom="large" style={style}>
      <DragDrop uppy={uppy} note={subTitle} height={height} />
      <StatusBar uppy={uppy} />
    </Box>
  )
}

ImageUppyUploadZone.propTypes = {
  allowedFileTypes: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  fieldName: PropTypes.string,
  height: PropTypes.string,
  imageType: PropTypes.string,
  imageableId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  imageableType: PropTypes.string.isRequired,
  style: PropTypes.object,
  subTitle: PropTypes.string,
  requestOptions: PropTypes.object,
}

ImageUppyUploadZone.defaultProps = {
  allowedFileTypes: 'image/*',
  height: '180px',
  requestOptions: {},
  subTitle: 'Max 13mb each',
}

export default ImageUppyUploadZone
